import "./App.css";
import { LocalizationProvider } from "@material-ui/lab";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { createTheTheme } from "./theme";
import { ThemeProvider } from "@emotion/react";
import { createHashHistory } from "history";
import { SnackbarProvider } from "notistack";
import serviceConfig from "./ServiceConfig";
import { enUS, it } from "date-fns/locale";

import Routes from "./routes/Routes";
import { HashRouter } from "react-router-dom";

const history = createHashHistory();

const newtheme = createTheTheme({
    direction: "ltr",
    responsiveFontSizes: true,
    roundedCorners: true,
    theme: "dark",
});

const onRedirectCallback = (appState: any) => {
    // eslint-disable-next-line no-restricted-globals
    history.push(appState && appState.returnTo ? appState.returnTo : window.location.pathname);
};

const providerConfig = {
    domain: serviceConfig.auth0Domain,
    clientId: serviceConfig.auth0ClientId,
    audience: null,
    redirectUri: window.location.origin,
    onRedirectCallback,
};

const locales: any = { enUS, it };

const App = () => {
    return (
        <>
            <ThemeProvider theme={newtheme}>
                <SnackbarProvider dense maxSnack={3}>
                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                        <HashRouter>
                            <Routes />
                        </HashRouter>
                    </LocalizationProvider>
                </SnackbarProvider>
            </ThemeProvider>
        </>
    );
};

export default App;
